export const whatsIncluded = 'whatsIncluded';
